import { cacheGet, cacheSet } from "@/lib/offline";
import { useState, useEffect } from "react";

// format a "HH:MM" 24h string into 12h ("9:10 AM") or 24h ("09:10")
export const formatTime = (t24, fmt = "12") => {
  if (!t24) return "";
  const [h, m] = t24.split(":").map(Number);
  if (fmt === "24") return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  const ap = h < 12 ? "AM" : "PM";
  const hh = h % 12 || 12;
  return `${hh}:${String(m).padStart(2, "0")} ${ap}`;
};

export const getTimeFormat = () => cacheGet("timeFormat") || "12";
export const setTimeFormat = (v) => {
  cacheSet("timeFormat", v);
  if (typeof window !== "undefined") window.dispatchEvent(new Event("timeformatchange"));
};

// App-wide reactive 12h/24h preference. Returns [fmt, setFmt].
export function useTimeFormat() {
  const [fmt, setFmt] = useState(getTimeFormat());
  useEffect(() => {
    const sync = () => setFmt(getTimeFormat());
    window.addEventListener("timeformatchange", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("timeformatchange", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return [fmt, (v) => setTimeFormat(v)];
}

// meters -> miles string (e.g., "0.28 mi", "1.2 mi")
export const formatMiles = (m) => {
  const mi = (m || 0) * 0.000621371;
  return `${mi < 1 ? mi.toFixed(2) : mi.toFixed(1)} mi`;
};

export const kmToMiles = (km) => (km || 0) * 0.621371;
